module.exports = __webpack_public_path__ + "img/fi-rr-ambulance.9379df25.svg";